module.exports = __webpack_public_path__ + "img/vidjet-logo-big.632d5a17.png";